/*
  CHN review auto-open (CH-REV-01, Anthony 2026-09-15T18:12:50Z).
  Opens the testimonials section's own "Leave a Review" popup, but only when the visitor arrives
  from the review email link (?judgeme_review_source=shareable-link or #judgeme).
  Any other visit: returns on the first line and does nothing.
  Loaded from sections/testimonials.liquid, only where that section renders the review modal.
  Waits up to 10s for the Judge.me form inside the popup; if it never appears, does nothing.
*/
(function () {
  if (window.chnReviewAutoOpen) return;
  window.chnReviewAutoOpen = true;
  if (window.Shopify && window.Shopify.designMode) return;

  // Our old Klaviyo link: ?judgeme_review_source=shareable-link#judgeme.
  // Judge.me's review_rating_url (the "Eligible for Judge.me Review Request" event, from 2026-09-15):
  // ?judgeme_review_source=<signed>&judgeme_token=<token>, no hash.
  var fromReviewEmail =
    /[?&]judgeme_review_source=shareable-link(&|$)/.test(window.location.search) ||
    /[?&]judgeme_token=[^&]+/.test(window.location.search) ||
    window.location.hash === '#judgeme';
  if (!fromReviewEmail) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var overlay = document.querySelector('[data-review-modal-overlay]');
    var button = document.querySelector('[data-open-review-modal]');
    var form = overlay && overlay.querySelector('.jdgm-form');
    if (overlay && button && form) {
      clearInterval(timer);
      if (overlay.classList.contains('is-open')) return;
      button.click();
      // Judge.me's own link handling scrolls its form inside the popup, which cuts off the heading.
      // For 3s after opening, undo any scroll the visitor didn't make, so it starts at the top like
      // a normal click. The first wheel, touch, key or mouse press hands scrolling back to them.
      var content = overlay.querySelector('.testimonials-review-modal__content');
      if (!content) return;
      var userScrolled = false;
      var markUser = function () { userScrolled = true; };
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
        overlay.addEventListener(type, markUser, { passive: true, once: true });
      });
      var keepTop = function () {
        if (!userScrolled && content.scrollTop !== 0) content.scrollTop = 0;
      };
      content.addEventListener('scroll', keepTop, { passive: true });
      content.scrollTop = 0;
      setTimeout(function () { content.removeEventListener('scroll', keepTop); }, 3000);
    } else if (tries >= 40) {
      clearInterval(timer);
    }
  }, 250);
})();
